import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["backdrop", "section", "content", "chevron"]

  connect() {
    // Close sidebar when clicking outside (mobile)
    if (this.hasBackdropTarget) {
      this.backdropTarget.addEventListener('click', () => this.close())
    }

    // Load section states from localStorage
    this.loadSectionStates()
  }

  // Mobile sidebar open/close
  open() {
    this.element.classList.remove('hidden')
  }

  close() {
    this.element.classList.add('hidden')
  }

  // Toggle collapsible sections
  toggleSection(event) {
    const button = event.currentTarget
    const section = button.closest('[data-sidebar-target="section"]')
    const content = section.querySelector('[data-sidebar-target="content"]')
    const chevron = section.querySelector('[data-sidebar-target="chevron"]')
    const sectionName = section.dataset.sectionName

    // Toggle content visibility
    content.classList.toggle('hidden')

    // Rotate chevron
    if (content.classList.contains('hidden')) {
      chevron.style.transform = 'rotate(-90deg)'
    } else {
      chevron.style.transform = 'rotate(0deg)'
    }

    // Save state to localStorage
    this.saveSectionState(sectionName, !content.classList.contains('hidden'))
  }

  // Load section states from localStorage
  loadSectionStates() {
    const states = this.getSectionStates()

    this.sectionTargets.forEach(section => {
      const sectionName = section.dataset.sectionName
      const content = section.querySelector('[data-sidebar-target="content"]')
      const chevron = section.querySelector('[data-sidebar-target="chevron"]')

      // Default to expanded (true) if no state saved
      const isExpanded = states[sectionName] !== false

      if (isExpanded) {
        content.classList.remove('hidden')
        chevron.style.transform = 'rotate(0deg)'
      } else {
        content.classList.add('hidden')
        chevron.style.transform = 'rotate(-90deg)'
      }
    })
  }

  // Get section states from localStorage
  getSectionStates() {
    const saved = localStorage.getItem('sidebar_sections_state')
    return saved ? JSON.parse(saved) : {}
  }

  // Save individual section state
  saveSectionState(sectionName, isExpanded) {
    const states = this.getSectionStates()
    states[sectionName] = isExpanded
    localStorage.setItem('sidebar_sections_state', JSON.stringify(states))
  }
}
